/**
 * Shared constants + label helpers used across the Admin Bookings UI.
 * Kept in one place so status/source colour palettes stay consistent
 * between the table, calendar, and PDF export.
 */

export const DEFAULT_SOURCES = ["internet", "ai_agent", "direct", "agency", "hotel", "other"];

export const SOURCE_LABEL = (s) =>
  (s || "internet").replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

export const SOURCE_TINT = {
  internet: "bg-sky-100 text-sky-800 dark:bg-sky-900/40 dark:text-sky-300",
  ai_agent: "bg-violet-100 text-violet-800 dark:bg-violet-900/40 dark:text-violet-300",
  direct:   "bg-neutral-200 text-neutral-800 dark:bg-neutral-700 dark:text-neutral-200",
  agency:   "bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300",
  hotel:    "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-300",
  other:    "bg-neutral-100 text-neutral-800 dark:bg-neutral-800 dark:text-neutral-300",
};

export const STATUS_OPTIONS = [
  { value: "pending", label: "Booking Request" },
  { value: "pending_payment", label: "Pending Payment" },
  { value: "confirmed", label: "Confirmed" },
  { value: "active", label: "In Rent / Active" },
  { value: "cancelled", label: "Cancelled" },
  { value: "completed", label: "Completed" },
  { value: "modification_requested", label: "Modification Requested" },
];

export const STATUS_TINT = {
  confirmed: "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-300",
  active: "bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-300",
  pending: "bg-sky-100 text-sky-800 dark:bg-sky-900/40 dark:text-sky-300",
  pending_payment: "bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300",
  cancelled: "bg-rose-100 text-rose-800 dark:bg-rose-900/40 dark:text-rose-300",
  completed: "bg-neutral-200 text-neutral-800 dark:bg-neutral-700 dark:text-neutral-200",
  modification_requested: "bg-amber-200 text-amber-900 dark:bg-amber-800/40 dark:text-amber-200",
};

export const PAYMENT_METHODS = [
  { value: "cash", label: "Cash" },
  { value: "bank_transfer", label: "Bank Transfer" },
  { value: "card_on_office", label: "Card on Office Payment" },
  { value: "paypal", label: "PayPal" },
  { value: "stripe", label: "Stripe" },
];

export const PAYMENT_METHOD_LABEL = Object.fromEntries(
  PAYMENT_METHODS.map((p) => [p.value, p.label]),
);

/** Statuses that require the operator to record a payment method. */
export const REQUIRES_PAYMENT_METHOD = new Set(["confirmed", "completed"]);
